var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoMapMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M256 0C161.5 0 85.1 76.4 85.1 170.9c0 29.9 7.9 58.3 22.1 83.5 2.4 3.9 4.7 7.9 7.1 11.8L256 512l141-245.8c2.4-3.2 3.9-6.3 6.3-10.2l1.6-2.4c14.2-24.4 22.1-52.8 22.1-83.5C426.9 76.4 350.5 0 256 0zm0 85.1c47.3 0 85.1 38.6 85.1 85.1 0 47.3-37.8 85.9-85.1 85.9s-85.1-38.6-85.1-85.1c0-47.3 37.8-85.9 85.1-85.9z",
    style: {
      fill: "#e74c3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 63.8c-59.1 0-106.3 48-106.3 106.3 0 59.1 48 106.3 106.3 106.3 59.1 0 106.3-48 106.3-106.3S315.1 63.8 256 63.8zm0 42.5c35.4 0 63.8 28.4 63.8 63.8s-28.4 63.8-63.8 63.8-63.8-28.4-63.8-63.8 28.4-63.8 63.8-63.8z",
    style: {
      fill: "#c0392b"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMapMarker);
export default __webpack_public_path__ + "static/media/ico_map_marker.4a5b4afc156b01e176f9bc3c5b8ff2b9.svg";
export { ForwardRef as ReactComponent };